import type { ComponentProps, Key } from 'react'
import { CircularProgress, Autocomplete as MuiAutocomplete, TextField } from '@mui/material'
import GlobalStyle from 'modules/styles'

type Props<T = string | number> = Pick<
  ComponentProps<typeof MuiAutocomplete<{ label: string; id: T }>>,
  'multiple' | 'options' | 'value' | 'isOptionEqualToValue' | 'onChange' | 'onBlur' | 'onOpen'
> & {
  error?: boolean
  helperText?: string
  isLoading?: boolean
  label?: string
  optionKey?: string
}

export default function AutocompleteField<T>({
  multiple = false,
  options = [],
  isOptionEqualToValue,
  error = false,
  helperText = '',
  isLoading = false,
  value,
  onChange,
  onBlur,
  onOpen,
  label,
  optionKey = 'id'
}: Props<T>) {
  return (
    <MuiAutocomplete
      multiple={multiple}
      disablePortal
      fullWidth
      options={options}
      isOptionEqualToValue={isOptionEqualToValue}
      onOpen={onOpen}
      onChange={onChange}
      onBlur={onBlur}
      ListboxProps={GlobalStyle.ListBox}
      value={value}
      renderOption={(props, opt) => (
        <li {...props} key={opt[optionKey as keyof typeof opt] as Key}>
          {opt.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  )
}
